<template>
  <div id="app">
    <qixi></qixi>
  </div>
</template>

<script>
import qixi from "./components/qixi";
export default {
  name: "app",
  components: { qixi }
};
</script>

<style>
#app{
  width: 100%;
  height:100vh;
}
</style>
